import { createAction } from '@reduxjs/toolkit';
import { DeepTagReportFiltersState } from '../types';

export const deepTagReportFiltersActions = {
  updateFilters: createAction<DeepTagReportFiltersState>('DeepTagReportFilters/UpdateFilters'),
};
